import React from 'react';


function DeclarationScopeAndLimitations() {
  return (
    <>

      <div className="max-w-4xl mx-auto py-12 px-6">
        <h1 className="text-3xl font-bold text-[#102A43] mb-8 border-b border-gray-200 pb-4">Declaration Scope and Limitations</h1>

        <div className="space-y-12 text-gray-800">
          
          {/* Section 1: Introduction */}
          <section>
             <p className="leading-relaxed mb-4">
               The AASC maintains a strict definition of what "Accountability Declaration" entails. It is a structural verification of governance controls, not a qualitative assessment of AI products.
             </p>
          </section>

          {/* Section 2: What declaration Confirms */}
          <section className="bg-green-50 p-6 border border-green-200 rounded-sm">
            <h2 className="text-xl font-bold text-green-900 mb-4 uppercase tracking-wide">1. What declaration Confirms</h2>
            <ul className="list-disc pl-5 space-y-2 text-green-900">
              <li><strong>Documented Accountability Boundaries:</strong> The existence of explicit scope definitions as required by mandatory standard <strong>AI-ABND-1.0</strong>.</li>
              <li><strong>Control Structures:</strong> The presence of documented governance policies (e.g., human-in-the-loop protocols, incident response plans).</li>
              <li><strong>Responsibility Domains:</strong> Evidence that human liability roles have been mapped to AI outputs.</li>
              <li><strong>Client Acknowledgment:</strong> Proof that clients have formally acknowledged the limitations of the AI system.</li>
              <li><strong>Structural Requirements Met:</strong> The organization demonstrated conformity to the AASC Standards Framework at the time of review.</li>
            </ul>
          </section>

          {/* Section 3: What declaration Does NOT Confirm */}
          <section className="bg-red-50 p-6 border border-red-200 rounded-sm">
            <h2 className="text-xl font-bold text-red-900 mb-4 uppercase tracking-wide">2. What declaration Does NOT Confirm</h2>
            <ul className="list-disc pl-5 space-y-2 text-red-900">
              <li><strong>System Performance:</strong> It does NOT guarantee that the AI system works correctly, accurately, or efficiently.</li>
              <li><strong>Safety or Security:</strong> It does NOT validate code security, penetration testing, or safety from jailbreaking.</li>
              <li><strong>Errors/Failures:</strong> It does NOT guarantee the system will be free from hallucinations or errors.</li>
              <li><strong>Regulatory Compliance:</strong> It does NOT constitute legal advice or confirm compliance with laws (e.g., EU AI Act, GDPR).</li>
              <li><strong>Endorsement:</strong> It does NOT imply AASC endorsement of the operator's business model or ethics.</li>
              <li><strong>Liability Transfer:</strong> The AASC assumes NO liability for the operator's actions.</li>
            </ul>
          </section>

          {/* Section 4: Point-in-Time Confirmation */}
          <section>
            <h2 className="text-xl font-bold text-[#102A43] mb-4 uppercase tracking-wide">3. Point-in-Time Confirmation</h2>
            <p className="leading-relaxed">
              declaration is a <strong>point-in-time assessment</strong>. It reflects the state of the operator's controls at the moment of the third-party review. The Council does not continuously monitor real-time operations, code changes, or model updates of declared entities.
            </p>
          </section>

          {/* Section 5: Liability Disclaimer */}
          <section>
            <h2 className="text-xl font-bold text-[#102A43] mb-4 uppercase tracking-wide">4. Liability Disclaimer</h2>
            <p className="leading-relaxed">
              The AASC assumes no liability for the actions, omissions, or failures of any operator, regardless of their registry status. The operator remains solely and exclusively liable for all services delivered to their clients.
            </p>
          </section>
        </div>
      </div>
    </>
  );
}

export default DeclarationScopeAndLimitations;